import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { SectionLabel } from "@/components/ui-bits";
import { Search, BookOpen, Sparkles } from "lucide-react";
import "@/components/meos-extra.css";

export default function KnowledgePanel() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [area, setArea] = useState("");

  const load = useCallback(async () => {
    const params = {};
    if (q) params.q = q;
    if (area) params.business_area = area;
    const { data } = await api.get("/decisions/knowledge/library", { params });
    setData(data);
  }, [q, area]);

  useEffect(() => { load(); }, [load]);

  if (!data) return <div className="empty-state">Loading knowledge center…</div>;

  return (
    <>
      <div className="toolbar">
        <div style={{ position: "relative", flex: 1, minWidth: 220 }}>
          <Search size={14} style={{ position: "absolute", left: 11, top: 10, color: "#9C978D" }} />
          <input className="filter-input" style={{ width: "100%", paddingLeft: 32 }} placeholder="Search lessons & decisions…"
            value={q} onChange={(e) => setQ(e.target.value)} data-testid="knowledge-search" />
        </div>
        <select className="filter-select" value={area} onChange={(e) => setArea(e.target.value)}>
          <option value="">All areas</option>{data.business_areas.map((a) => <option key={a}>{a}</option>)}
        </select>
      </div>

      <SectionLabel>Executive Knowledge Center — lessons learned from completed decisions</SectionLabel>
      <div data-testid="knowledge-list">
        {data.items.length === 0 && <div className="card"><div className="empty-state">No completed decisions yet. Outcomes appear here as decisions reach Completed.</div></div>}
        {data.items.map((k) => (
          <div className="card" key={k.id}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 10, justifyContent: "space-between" }}>
              <div style={{ flex: 1 }}>
                <div className="card-title" style={{ marginBottom: 4 }}>
                  <BookOpen size={13} style={{ verticalAlign: "middle", marginRight: 6, color: "#1F75A8" }} />{k.title}
                  {k.source === "Executive Advisor" && <span className="badge-prio prio-Medium" style={{ marginLeft: 8, background: "#EEEDFE", color: "#3C3489" }}>Advisor</span>}
                </div>
                <div className="decision-meta">{k.category} · {k.business_area} · {(k.date_created || "").slice(0, 10)}</div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                {k.success_pct != null && <span className="source-badge src-live">Success {k.success_pct}%</span>}
                {k.roi_pct != null && <span className="source-badge src-seed">ROI {k.roi_pct}%</span>}
                {k.goal_achievement && <span className="source-badge src-seed">{k.goal_achievement}</span>}
              </div>
            </div>
            {k.lessons_learned && <div className="detail-block" style={{ marginTop: 10 }}><div className="detail-label">Lessons learned</div><div className="detail-value">{k.lessons_learned}</div></div>}
            {k.next_steps && <div className="detail-block"><div className="detail-label">Recommended next steps</div><div className="detail-value">{k.next_steps}</div></div>}
            <div className="info-note" style={{ marginTop: 8 }}>recommendation_id: {k.recommendation_id || "—"} · outcome_id: {k.outcome_id ? k.outcome_id.slice(0, 8) : "—"} — available for future AI advisor reasoning</div>
          </div>
        ))}
      </div>
    </>
  );
}
